import {PersonLegalRole} from '@modifi/enums'
import {NewPersonIdentificationView} from '@modifi/onboarding-api-clients'

export const LEGAL_ROLE_PROPERTY_MAP: Record<
  PersonLegalRole,
  (keyof NewPersonIdentificationView)[]
> = {
  [PersonLegalRole.LEGAL_REPRESENTATIVE]: [
    'directorIdentificationNumber',
    'position',
    'typeOfRepresentation',
    'votingShare',
    'isSignatory',
  ],
  [PersonLegalRole.BENEFICIAL_OWNER]: [
    'directorIdentificationNumber',
    'position',
    'typeOfRepresentation',
    'uboOtherReason',
    'votingShare',
  ],
  [PersonLegalRole.DIRECTOR]: ['directorIdentificationNumber', 'position'],
}
